import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Dots } from '@mentimeter/visualizations-react/visualizations/dots';
import type { ChoicesVisualizationProps } from '../types';

export const DotsDataHandler = ({
  results,
  choices,
  shouldHideResults,
  shouldAnimate,
}: ChoicesVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor },
      fonts: { body },
    },
  } = useRagnar();

  const { results: currentResults } = results;

  const visualizationData = currentResults.map((result) => ({
    id: result.id,
    score: result.score.reduce((acc, score) => acc + score, 0),
  }));

  return (
    <Box px="space2" width="100%" height="100%">
      <FullSizeContainer>
        {(width, height) => (
          <Dots
            width={width}
            height={height}
            colors={fillColors as [string, ...string[]]}
            data={visualizationData}
            staticOptions={choices}
            disableAnimations={!shouldAnimate}
            isScoreHidden={shouldHideResults}
            textColor={textColor}
            fontFamily={body}
          />
        )}
      </FullSizeContainer>
    </Box>
  );
};
